import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";

const Subnav = ({ subItem, setSideBar, ...props }) => {
  const [subnav, setSubnav] = useState(false);
  let history = useHistory();

  const showSubNav = () => {
    if (subItem.subNav) {
      setSubnav(!subnav);
    } else {
      if (setSideBar) {
        setSideBar(false);
      }
    }
  };

  return (
    <>
      <div
        className={`SubnavLink ${
          history.location.pathname === subItem.path ? "selected-nav-item" : ""
        }`}
      >
        {subItem.subNav ? (
          <div
            className="d-flex align-items-center w-100 nav-padding"
            onClick={() => {
              showSubNav();
            }}
          >
            <div className="SubnavAnchorContent">
              {subItem?.image ? (
                <img src={subItem?.image} />
              ) : (
                <>{subItem?.icon}</>
              )}
              <div className="SubnavLabel">{subItem?.title}</div>
            </div>
            <div className="SubnavIcon">
              {subItem.subNav && subnav
                ? subItem.iconOpened
                : subItem.subNav
                ? subItem.iconClosed
                : null}
            </div>
          </div>
        ) : subItem?.path?.includes("https://") ? (
          <a
            href={subItem.path}
            className="d-flex align-items-center text-white w-100 nav-padding"
          >
            {subItem?.image ? (
              <img src={subItem?.image} />
            ) : (
              <>{subItem?.icon}</>
            )}
            <div className="SidebarLabel">{subItem?.title}</div>
          </a>
        ) : (
          <Link
            className="d-flex align-items-center text-white w-100 nav-padding"
            to={subItem?.path}
          >
            {subItem?.image ? (
              <img src={subItem?.image} />
            ) : (
              <>{subItem?.icon}</>
            )}
            <div className="SidebarLabel">{subItem?.title}</div>
          </Link>
        )}
      </div>
      {subnav &&
        subItem?.subNav?.map((subItem, index) => {
          return <Subnav subItem={subItem} key={index} />;
        })}
    </>
  );
};

export default Subnav;
